module.exports = __webpack_public_path__ + "static/media/preview-eye-icon.8c965ba9.png";